import {
  caetano_go__check_redirection,
  caetano_go__init
} from "../caetano-go";

const $ = window.jQuery;

const getDataLayerParams = ($el) => {
  return {
    productType: $el.attr('data-product-type'),
    pickUpCountry: $el.attr('data-pick-up-country'),
    pickUpCity: $el.attr('data-pick-up-city'),
    dropOffCity: $el.attr('data-drop-off-city'),
    pickUpOffice: $el.attr('data-pick-up-office'),
    pickUpOfficeType: $el.attr('data-pick-up-office-type'),
    dropOffOffice: $el.attr('data-drop-off-office'),
    dropOffOfficeType: $el.attr('data-drop-off-office-type'),
    customerCountry: $el.attr('data-customer-country'),
    searchMode: $el.attr('data-search-mode'),
    bookingDuration: $el.attr('data-booking-duration'),
    currencyCode: $el.attr('data-currency-code'),
    oneWay: $el.attr('data-one-way'),
    driversAge: $el.attr('data-drivers-age'),
  }
};

const getDataLayerDeviceSuffix = () => {
  const $html = $('html');
  if ($html.hasClass('device-desktop') || $html.hasClass('device-tablet')) {
    return 'desk';
  }
  return 'mob';
}

const getDataLayerParamsForEvent = (dataLayerParams, eventName, dataLayerDeviceSuffix) => {
  return {
    event: eventName + '-' + dataLayerDeviceSuffix,
    eventType: dataLayerParams.pickUpCity,
    eventDetail: dataLayerParams.pickUpOffice,

    ...dataLayerParams,
  }
};

const removeBodyStyles = () => {
  $('body').attr('style', '');
};

const run = () => {
  $(document).ready(function() {
    window.addEventListener('CookiebotOnAccept', removeBodyStyles, false);
    window.addEventListener('CookiebotOnDecline', removeBodyStyles, false);

    caetano_go__init();

    // language-select
    $('[pepe-language-select]').click(function() {
      $(this).toggleClass("open");
      $('.language-bg-layer').toggleClass("open");
    });
    $('#language-select').click(function() {
      $(".layout-header__select").toggleClass("open");
    });

    $('[pepe-rac-offer]').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      const dataLayerParams = getDataLayerParams($(this));
      const dataLayerDeviceSuffix = getDataLayerDeviceSuffix();
      window.dataLayer.push(getDataLayerParamsForEvent(dataLayerParams, 'gtm-pickup-office-selected', dataLayerDeviceSuffix))
      window.dataLayer.push(getDataLayerParamsForEvent(dataLayerParams, 'gtm-date-selected', dataLayerDeviceSuffix))
      window.dataLayer.push(getDataLayerParamsForEvent(dataLayerParams, 'gtm-search-form-submit', dataLayerDeviceSuffix))
      window.dataLayer.push(getDataLayerParamsForEvent(dataLayerParams, 'gtm-booking-offer-preselected', dataLayerDeviceSuffix))
      window.location.href = $(this).attr('href');
    });

    // nav-bar
    $('[pepe-navbar]').click(function() {
      $(this).toggleClass("open");

      $('.layout-header__side-menu').toggleClass('open');
      $('.layout-header__select').removeClass("open");
      $('.language-bg-layer').removeClass("open");
      // does 'visually-hidden' class come from Drupal? if so, remove from there, else we will need something like this ⬇
      $('.layout-header__side-menu .visually-hidden').toggleClass('visually-hidden');
      if ($(window).width() <= 768) {
        $('.layout-header__side-menu .layout-header__select').after($('#top-menu-options'))
      }

      $('body').toggleClass('not-overflow');
    });
  });
};

export default run;
